export const AUTH_CONFIG = {
    clientId: 'YOrYAyASMIsbT3C16FItGgvlBlA4kk9E',
    domain: 'hiacode.auth0.com',
    callbackUrl: window.location.origin,
    apiUrl: '{API_IDENTIFIER}'
}
